
module.exports = {
    init: function()
    {
        let progBar = document.querySelector("#article-progress-bar .article-progress-bar-fill");

        if(progBar) {

            window.addEventListener("scroll", function(evt) {

                let curScroll = document.documentElement.scrollTop;

                let limit = Math.max( document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) - window.innerHeight;

                progBar.style.width = (curScroll * 100 / limit) + "%";
            })
        }

    }
}
